import {Button, IconButton} from '@wandb/components';
import React, {useCallback} from 'react';

import {trackSetting} from '../../services/analytics/workspaceSettingsEvents';
import {DD_PRIVACY_ALLOW} from '../../util/datadog/privacy';
import {useWorkspaceDrawerContext} from '../WorkspaceDrawer/WorkspaceDrawerContextProvider';

export const WorkspaceSettings = ({isIconOnly}: {isIconOnly?: boolean}) => {
  const {toggleWorkspaceDrawer, contentType} = useWorkspaceDrawerContext();

  const onClick = useCallback(() => {
    toggleWorkspaceDrawer('workspace-settings');
    if (contentType == null) {
      trackSetting({
        action: 'open drawer',
        page: 'workspace',
      });
    }
  }, [contentType, toggleWorkspaceDrawer]);

  if (isIconOnly) {
    return (
      <IconButton
        aria-label="Workspace settings"
        data-dd-action-name="Workspace settings"
        data-dd-privacy={DD_PRIVACY_ALLOW}
        data-test="workspace-settings-button"
        icon="settings"
        onPress={onClick}
        tooltip={{children: 'Workspace settings', placement: 'bottom'}}
        variant="secondary"
      />
    );
  }

  return (
    <Button
      aria-label="Workspace settings"
      data-dd-action-name="Workspace settings"
      data-dd-privacy={DD_PRIVACY_ALLOW}
      data-test="workspace-settings-button"
      startIcon="settings"
      onPress={onClick}
      tooltip={{children: 'Workspace settings', placement: 'bottom'}}
      variant="secondary">
      Settings
    </Button>
  );
};
